import { render, staticRenderFns } from "./CreateElection.vue?vue&type=template&id=89a3fe8c&"
import script from "./CreateElection.vue?vue&type=script&lang=js&"
export * from "./CreateElection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports